<template>
  <div class="steps-wrapper">
    <p class="top-text">
      Ops, parece que você ainda não tem nenhuma assistente virtual cadastrada ainda
    </p>

    <div class="steps-grid">
      <StepCard
        :stepNumber="1"
        title="Prompt da IA"
        description="Insira as instruções da sua assistente virtual, como:"
        :items="[
          'Objetivo:',
          'Script de atendimento',
          'Horários de atendimento',
          'Endereço da sua loja'
        ]"
      />

      <StepCard
        :stepNumber="2"
        title="Cadastre sua base de conhecimento"
        description="Insira documentos e sites que a IA deve consultar ao longo do atendimento."
        :items="[
          'Tabela de preços',
          'Manual da marca',
          'Site da sua empresa',
          'FAQ da sua operação'
        ]"
      />

      <StepCard
        :stepNumber="3"
        title="Integre com o builder."
        description="Sua assistente virtual funciona diretamente no builder (construtor de bots) do Conversx."
        :items="[
          'Colocar a assistente para rodar apenas em horário comercial',
          'Assiste atender apenas no menu de novos',
          'E muito mais'
        ]"
      />
    </div>

    <p class="footer-text">
      Obs: A assistente virtual possui custos extras, a parte do pacote de conversas.
      Consulte seu gerente de contas para mais informações
    </p>
  </div>
</template>

<script>
import StepCard from "shared/components/StepCard";

export default {
  name: "StepsSection",
  components: {
    StepCard,
  },
};
</script>

<style scoped>
.steps-wrapper {
  padding: 30px 20px;
}

/* Texto topo */
.top-text {
  font-size: 14px;
  margin-bottom: 30px;
  font-weight: var(--font-weight-bold);
}

/* Grid dos cards */
.steps-grid {
  display: flex;
  justify-content: center;
  gap: 30px;
  flex-wrap: wrap;
}

/* Rodapé */
.footer-text {
  font-size: 12px;
  margin-top: 30px;
  font-weight: var(--font-weight-medium);
}
</style>